<template>
  <div class="tiltPhone">
    <div class="tiltPhone__content">
      <icon-tilt></icon-tilt>
      <h2 v-html="title"></h2>
      <div v-html="description"></div>
    </div>
  </div>
</template>

<script>
  import TiltIcon from './icons/TiltPhone';

  export default{
    data(){
      return {
        title: '',
        description: ''
      }
    },
    components: {
      'icon-tilt': TiltIcon
    },
    created(){
      var vm = this;
      this.title = vm.$store.state.labels.rotateDeviceTitle;
      this.description = vm.$store.state.labels.rotateDeviceDescription;
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/TiltPhone.vue